(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('errorMsgService', errorMsgService)
    .factory('msgService', msgService);

    /**
    * @ngdoc service
    * @name swif.framework.errorMsgService
    **/
    function errorMsgService($injector) {
        var errors = [];
        return {
            /**
            * @ngdoc method
            * @name addError
            * @methodOf swif.framework.errorMsgService
            * @description add an error to the list
            * @param {Object} msg the error to send
            **/
            addError: function (msg){
                if (_.isObject(msg)) {
                    if (msg.data) {
                        if (msg.data.fault_code) {
                            var split = ('' + msg.data.fault_code).split('\n')[0].split(' -- ');
                            if (split.length > 1) {
                                msg.type = split.shift();
                                msg.data.fault_code = msg.data.fault_code.substr(msg.type.length + 4);
                            }
                        }
                    }
                    //delete password values from http params
                    var RM_KEYS = ['password'];
                    if (msg.swif) {
                        if (msg.swif.http) {
                            if (msg.swif.http.params) {
                                var params = msg.swif.http.params;
                                if (params.fields && _.isArray(params.fields)) {
                                    _.forEach(params.fields, function (field) {
                                        if (field.value) {
                                            field.value = '';
                                        }
                                    });
                                } else {
                                    _.forEach(RM_KEYS, function (key) {
                                        if (params[key]) {
                                            params[key] = '';
                                        }
                                    });
                                }
                            }
                        }
                    }
                    var message = {type: 'danger', text: msg};
                    var found = false;
                    _.forEach(errors, function (error) {
                        if (error.text.status === msg.status) {
                            found = true;
                        }
                    });
                    if (!found) {
                        errors.push(message);
                    }
                }
            },
            /**
            * @ngdoc method
            * @name getErrors
            * @methodOf swif.framework.errorMsgService
            * @description get a reference to the Array of errors
            * @return {Array} errors
            **/
            getErrors: function () {
                return errors;
            },
            /**
            * @ngdoc method
            * @name closeError
            * @methodOf swif.framework.errorMsgService
            * @description remove an error from the array
            * @param {Number} msg the indice of the message in the array
            **/
            closeError: function (msg) {
                if (typeof msg === 'number'){
                    errors.splice(msg, 1);
                }
            },
            /**
            * @ngdoc method
            * @name clearErrors
            * @methodOf swif.framework.errorMsgService
            * @description remove all errors
            **/
            clearErrors: function () {
                while(errors.length > 0) {
                    errors.pop();
                }
            },
            /**
             * @ngdoc method
             * @name logToSentry
             * @methodOf swif.framework.errorMsgService
             * @description Log passed error to Sentry service. Event fired from exception handler only.
             */
            logToSentry: function (error) {
                var swif = $injector.get('swifFrameworkService');
                // Send error to Sentry if on production environment
                if (ON_PRODUCTION) {
                    var u = swif.user.getAuthenticatedUserData();
                    Raven.setUserContext({
                        id: u.id,
                        complete_name: u.complete_name,
                        email: u.email
                    });
                    Raven.setExtraContext({ settings: swif.settings.app });
                    Raven.captureException(error);
                }
            }
        };
    }


    /**
    * @ngdoc service
    * @name swif.framework.msgService
    * @description this service provide an API to display feedback to the user.
    **/
    function msgService($uibModal, notificationService, ngProgressFactory, errorMsgService, gettextCatalog) {
        'ngInject';
        var messages = [];
        var ngProgress = ngProgressFactory.createInstance();
        PNotify.prototype.options.styling = "bootstrap3";
        return {
            /**
            * @ngdoc method
            * @name addInfo
            * @methodOf swif.framework.msgService
            * @description display tiny notification on the top right in blue background
            * @param {String} msg the message to send
            * @returns {Promise} notification.info
            **/
            addInfo: function (msg){
                var translated = gettextCatalog.getString(msg);
                return notificationService.info(translated);
            },
            /**
            * @ngdoc method
            * @name addError
            * @methodOf swif.framework.msgService
            * @description display modal with info about the error
            * @param {Object} msg the error
            **/
            addError: function (msg){
                errorMsgService.addError(msg);
            },
            /**
            * @ngdoc method
            * @name addNotice
            * @methodOf swif.framework.msgService
            * @description display tiny notification on the top right in orange background
            * @param {String} msg the message to send
            * @returns {Promise} notification.notice
            **/
            addNotice: function (msg){
                var translated = gettextCatalog.getString(msg);
                return notificationService.notice(translated);
            },
            addGenericMsg: function (msg, opt){
                var translated = gettextCatalog.getString(msg);
                opt = opt || {};
                opt.text = translated;
                return notificationService.notify(opt);
            },
            addDeferredMsg: function (msg, deferred) {
                var self = this;
                var translated = gettextCatalog.getString(msg);
                // delay: 60000 => 1 min of network timeout, wait & see :)
                var options = {
                    icon: 'fa fa-refresh fa-spin fa-fw',
                    type: 'notice',
                    delay: 60000,
                    after_open: function (item) {
                        deferred.then(function () {
                            self.addInfo('action completed successfully');
                        });
                        deferred.finally(function () {
                            item.elem.fadeOut('slow').remove();
                        });
                    }
                };
                this.addGenericMsg(translated, options);
            },
            /**
            * @ngdoc method
            * @name addWarning
            * @methodOf swif.framework.msgService
            * @description display tiny notification on the top right in orange background
            * @param {String} msg the message to send
            * @returns {Promise} notification.notice
            **/
            addWarning: function (msg){
                var translated = gettextCatalog.getString(msg);
                return notificationService.notice(translated);
            },
            /**
            * @ngdoc method
            * @name getMessages
            * @methodOf swif.framework.msgService
            * @returns {Array} array of messages
            **/
            getMessages: function () {
                return messages;
            },
            /**
            * @ngdoc method
            * @name getErrors
            * @methodOf swif.framework.msgService
            * @returns {Array} array of errors
            **/
            getErrors: function () {
                errorMsgService.getErrors();
            },
            clearMessages: function () {
                for (var i = 0; i < messages.length; i++) {
                    if (messages[i].type === 'danger'){
                        continue;
                    }else{
                        messages.splice(i, 1);
                    }
                }
            },
            /**
            * @ngdoc method
            * @name clearErrors
            * @methodOf swif.framework.msgService
            **/
            clearErrors: function () {
                errorMsgService.clearErrors();
            },
            /**
            * @ngdoc method
            * @name closeMessage
            * @methodOf swif.framework.msgService
            * @description remove the message from it's container.
            * @param {Number or Object} msg the message
            * @param {Array} container the container of the message
            **/
            closeMessage: function (msg, container) {
                if (container === undefined) {
                    container = messages;
                }
                if (typeof msg === 'number'){
                    container.splice(msg, 1);
                }else{
                    for (var i = 0; i < container.length; i++) {
                        if (msg.text === container[i].text){
                            container.splice(i, 1);
                        }
                    }
                }
            },
            parseError: function (error) {
                this.addError(error);
            },
            /**
            * @ngdoc method
            * @name loading
            * @methodOf swif.framework.msgService
            * @description manage loading object
            * @param {Object} data the loading object {loading: false, ko: false, ok: false}
            * @param {String} newStatus undefined / 'ok' / 'ko'
            **/
            loading: function (data, newStatus) {
                if (newStatus === undefined) {
                    data.loading = true;
                    data.ok = false;
                    data.ko = false;
                }else if (newStatus === 'ok') {
                    data.loading = false;
                    data.ko = false;
                    data.ok = true;
                }else{
                    data.loading = false;
                    data.ok = false;
                    data.ko = true;
                }
            },
            /**
            * @ngdoc method
            * @name setProgress
            * @methodOf swif.framework.msgService
            * @description update the progress bar
            * @param {Number} nb 0 - 100
            **/
            setProgress: function (nb) {
                ngProgress.set(nb);
            },
            addOnErrorHandler: function (scope, func) {
                var self = this;
                scope.onError = function (error) {
                    self.addError(error);
                    if (func) {
                        func(error);
                    }
                };
            },
            progress: false,
            countRequests: 0,
            /**
            * @ngdoc method
            * @name updateProgress
            * @methodOf swif.framework.msgService
            * @description update the progress using countRequest
            **/
            updateProgress: function () {
                var progress = 100 / (1 + this.countRequests);
                ngProgress.updateCount(progress);
            },
            /**
            * @ngdoc method
            * @name startRequest
            * @methodOf swif.framework.msgService
            * @description track one more request
            **/
            startRequest: function () {
                this.countRequests += 1;
                if (!this.progress) {
                    this.progress = true;
                    ngProgress.start();
                    ngProgress.setColor('#5bc0de');
                }
                this.updateProgress();
            },
            /**
            * @ngdoc method
            * @name stopRequest
            * @methodOf swif.framework.msgService
            * @description stop one request as finished (nevermind if OK or KO)
            **/
            stopRequest: function () {
                this.countRequests = this.countRequests - 1;
                if (this.countRequests <= 0) {
                    this.progress = false;
                    ngProgress.complete();
                    this.countRequests = 0;
                } else {
                    this.updateProgress();
                }
            }
        };
    }

})();
